import { render, staticRenderFns } from "./deposit-table-saving-data.vue?vue&type=template&id=6a12d41e"
import script from "./deposit-table-saving-data.vue?vue&type=script&lang=js"
export * from "./deposit-table-saving-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports